module.exports = __webpack_public_path__ + "static/media/FrostDesign.e738f491.svg";